import { useQuery } from '@apollo/react-hooks'
import SETTINGS from 'apollo/queries/SETTINGS.graphql'
import { Settings } from 'apollo/__generated_types__/Settings'

export default () => {
	return useQuery<Settings>(SETTINGS)
}
